/**
 * ProductSlide Component - Created by david on 12/02/18.
 */
import * as React from 'react'
import Checkbox from 'antd/lib/checkbox'
import { ImageContainer, ImageTop, Image, Page } from './styledComponents'

interface Props {
  image?: string
  onChange: React.ChangeEventHandler<HTMLInputElement>
  checked: boolean
  disabled: boolean
  withCheckbox: boolean
  fromNotes: boolean
  handleClick?: () => void
}

const ProductSlide = ({
  image,
  fromNotes,
  onChange,
  checked,
  disabled,
  withCheckbox,
  handleClick = () => {}
}: Props) => {
  return (
    <ImageContainer {...{ fromNotes }}>
      {withCheckbox && 
        <ImageTop>
          <Checkbox {...{ checked, onChange, disabled }} />
        </ImageTop>
      }
      <Page {...{ fromNotes }}>
        <Image {...{ fromNotes}} onClick={handleClick} withCursor={!withCheckbox} src={image} />
      </Page>
    </ImageContainer>
  )
}

export default ProductSlide



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignsPrintModal/ProductThumbnailStore/ProductImage/index.tsx